import Axios from "axios";

// state
const state = {
  plans: [],
  planOverview: {
    name: "",
    depletion: "",
    renew: "",
    renewDay: "",
    utilization: {
      current: 0,
      max: 0
    }
  }
};

// getters
const getters = {};

// actions
const actions = {
  async getPlans({ commit }: any, onlyPaid = false) {
    const params = onlyPaid
      ? {
          onlypaid: true
        }
      : null;
    await Axios.get("/api/v1/listplans", { params })
      .then((response) => {
        commit("UPDATE_PLANS", response.data);
      })
      .catch(() => {
        //
      });
  },
  async getPlanOverview({ commit }: any) {
    await Axios.get("/api/v1/profile/plan/overview")
      .then((response) => {
        commit("UPDATE_PLAN_OVERVIEW", response.data);
      })
      .catch(() => {
        //
      });
  }
};

// mutations
const mutations = {
  UPDATE_PLANS(state: any, plans: any) {
    state.plans = plans;
  },
  UPDATE_PLAN_OVERVIEW(state: any, overview: any) {
    state.planOverview = overview;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
